
import { OptionsAttribute, RichTextAttribute } from '../../../../types/designer-attribute-type';
import { BaseDesignerComponent } from '../../base/base-designer-component';
import { ControlSafeHtmlPipe } from '../../../shared/control-source-type-pipe';
import { Component, ElementRef } from '@angular/core';

@Component({
    selector: 'sx-paragraph-designer',
    templateUrl: './paragraph-designer-component.html'
})

export class SxParagraphDesigner extends BaseDesignerComponent {
    constructor(container: ElementRef) {
        super(container, 'SxParagraph');
    }
    loadDefaults(): void {
        super.loadDefaults();
        this.controlContext.text = '';
    }

    getDesignerInfo(): any {
        const info = super.getDesignerInfo();

        info['text'] = this.controlContext.text;
        info['textType'] = this.controlContext.textType;
        return info;
    }
    buildAttributes(): void {
        super.buildAttributes();

        const paragraphAtt = new RichTextAttribute(this.controlContext, 'text', 'Text');
        const types = [
            { id: 'staticFlat', name: 'Static' },
            { id: 'staticReplace', name: 'Static Replace' },
           // { id: 'staticJS', name: 'Static JS' },
            //      { id: 'dynamicJS', name: 'Dynamic JS' },
        ];
        const type = new OptionsAttribute(this.controlContext, types, 'textType', 'Title display Type');

        this.attributes.push(paragraphAtt);
        this.attributes.push(type);
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/text-editors/paragraph-designer-component.ts